export default __webpack_public_path__ + "static/media/icon_nodejs.007e99f6.png";